const chapter = {
  id: 'polymers',
  slug: 'polymers',
  subject: 'chemistry',
  subjectLabel: 'Chemistry',
  exam: 'JEE Main + NEET',
  title: {
    english: 'Polymers',
        hindi: 'बहुलक',
  },
  estReadMinutes: 45,
  difficulty: {
    english: 'Easy-Medium',
        hindi: 'आसान-मध्यम',
  },
  weightage: {
    english: '1–2 questions in JEE Main / NEET',
        hindi: 'जेईई मेन/नीट में 1-2 प्रश्न',
  },
  syllabusTags: ['Organic Chemistry', 'JEE-Main', 'NEET', 'Class-12'],
  sections: [
    {
      id: 'classification',
      title: {
        english: 'Classification of Polymers',
        hindi: 'बहुलकों का वर्गीकरण',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Polymer = high-mass macromolecule formed by repeating monomers; **degree of polymerisation** $n$ very large.',
        hindi: 'Polymer = high-mass macromolecule formed by repeating monomers; **पोलीमराइजेशन की डिग्री** $n$ बहुत बड़ी। **स्रोत द्वारा**: प्राकृतिक (रबड़, सेलूलोज़, प्रोटीन, स्टार्च); अर्ध-सिंथेटिक (सेलूलोज़ नाइट्रेट, रेयान); सिंथेटिक (पॉलीथीन, नायलॉन, पीवीसी)। **संरचना द्वारा**: रैखिक (एचडीपीई), शाखित (एलडीपीई), क्रॉस-लिंक्ड / नेटवर्क (बैकेलाइट, वल्केनाइज्ड रबर)।',
            },
            {
              english: '**By source**: natural (rubber, cellulose, proteins, starch); semi-synthetic (cellulose nitrate, rayon); synthetic (polyethene, nylon, PVC).',
        hindi: '**स्रोत द्वारा**: प्राकृतिक (रबड़, सेलूलोज़, प्रोटीन, स्टार्च); अर्ध-सिंथेटिक (सेलूलोज़ नाइट्रेट, रेयान); सिंथेटिक (पॉलीथीन, नायलॉन, पीवीसी)।',
            },
            {
              english: '**By structure**: linear (HDPE), branched (LDPE), cross-linked / network (bakelite, vulcanised rubber).',
        hindi: '**संरचना द्वारा**: रैखिक (एचडीपीई), शाखित (एलडीपीई), क्रॉस-लिंक्ड / नेटवर्क (बैकेलाइट, वल्केनाइज्ड रबर)।',
            },
            {
              english: '**By mode of polymerisation**:',
        hindi: '**पोलीमराइजेशन की विधि द्वारा**:',
            },
            {
              english: '• **Addition** (chain growth) — monomers with C=C add together; no by-product. Free radical / cationic / anionic / coordination (Ziegler-Natta).',
        hindi: '• **अतिरिक्त** (श्रृंखला वृद्धि) - C=C add together के साथ मोनोमर्स; कोई उपोत्पाद नहीं. मुक्त मूलक/धनायनिक/आयनिक/समन्वय (ज़ीग्लर-नट्टा)।',
            },
            {
              english: '• **Condensation** (step growth) — bifunctional monomers join with elimination of small molecule (H₂O, NH₃, HCl).',
        hindi: '• **संक्षेपण** (चरण वृद्धि) - द्विकार्यात्मक मोनोमर्स छोटे अणु (H₂O, NH₃, HCl) के उन्मूलन के साथ जुड़ते हैं।',
            },
            {
              english: '**By thermal behaviour**:',
        hindi: '**थर्मल व्यवहार द्वारा**:',
            },
            {
              english: '• **Thermoplastic** — soften on heating, can be remoulded (PE, PVC, polystyrene).',
        hindi: '• **थर्मोप्लास्टिक** - गर्म करने पर नरम हो जाता है, दोबारा ढाला जा सकता है (पीई, पीवीसी, पॉलीस्टाइनिन)।',
            },
            {
              english: '• **Thermosetting** — set permanently on first heating; cannot be remoulded (bakelite, melamine, urea-formaldehyde).',
        hindi: '• **थर्मोसेटिंग** - पहली हीटिंग पर स्थायी रूप से सेट करें; दोबारा ढाला नहीं जा सकता (बेकेलाइट, मेलामाइन, यूरिया-फॉर्मेल्डिहाइड)।',
            },
            {
              english: '**By forces**:',
        hindi: '**बलों द्वारा**:',
            },
            {
              english: '• Elastomer (weak forces, very flexible — rubber).',
        hindi: '• इलास्टोमेर (कमजोर बल, बहुत लचीला - रबर)।',
            },
            {
              english: '• Fibre (strong H-bond / dipole, oriented chains — nylon, polyester).',
        hindi: '• फाइबर (मजबूत एच-बॉन्ड / द्विध्रुवीय, उन्मुख श्रृंखला - नायलॉन, पॉलिएस्टर)।',
            },
            {
              english: '• Thermoplastic (intermediate).',
        hindi: '• थर्मोप्लास्टिक (मध्यवर्ती)।',
            },
          ],
        },
      ],
    },
    {
      id: 'addition',
      title: {
        english: 'Addition Polymers',
        hindi: 'योगज बहुलक',
      },
      blocks: [
        {
          type: 'table',
          headers: ['Polymer', 'Monomer', 'Use'],
          rows: [
            ['Polythene LDPE', 'Ethene (high P, free-radical)', 'Squeeze bottles'],
            ['Polythene HDPE', 'Ethene (Ziegler-Natta, low P)', 'Pipes, bottles'],
            ['Polypropene', 'Propene', 'Ropes, fibres'],
            ['PVC', 'Vinyl chloride', 'Pipes, raincoats'],
            ['PTFE (Teflon)', 'Tetrafluoroethene', 'Non-stick coating'],
            ['Polystyrene', 'Styrene', 'Insulation, packing'],
            ['PAN (Orlon)', 'Acrylonitrile', 'Synthetic wool'],
            ['PMMA (Plexiglass)', 'Methyl methacrylate', 'Acrylic sheets, lenses'],
          ],
        },
        {
          type: 'list',
          items: [
            {
              english: '**Free-radical** mechanism: initiator (benzoyl peroxide) → radical → adds to C=C → chain propagation → termination (combination/disproportionation).',
        hindi: '**फ्री-रेडिकल** तंत्र: आरंभकर्ता (बेंज़ॉयल पेरोक्साइड) → रेडिकल → C=C → chain propagation → termination (संचय/disproportionation) में जोड़ता है।',
            },
            {
              english: 'Ziegler-Natta catalyst $TiCl_4 + Al(C_2H_5)_3$ gives stereoregular (isotactic, syndiotactic) polymers.',
        hindi: 'ज़िग्लर-नट्टा उत्प्रेरक $TiCl_4 + Al(C_2H_5)_3$ स्टीरियोरेगुलर (आइसोटैक्टिक, सिंडियोटैक्टिक) पॉलिमर देता है।',
            },
          ],
        },
      ],
    },
    {
      id: 'condensation',
      title: {
        english: 'Condensation Polymers',
        hindi: 'संघनन बहुलक',
      },
      blocks: [
        {
          type: 'table',
          headers: ['Polymer', 'Monomers', 'Linkage', 'Use'],
          rows: [
            ['Nylon-6,6', 'Hexamethylenediamine + adipic acid', 'Amide', 'Ropes, carpets, fabrics'],
            ['Nylon-6', 'Caprolactam (ring opening)', 'Amide', 'Tyre cord, fabric'],
            ['Nylon-2-Nylon-6 (biodegradable)', 'Glycine + amino caproic acid', 'Amide', 'Surgical sutures'],
            ['Terylene (Dacron, PET)', 'Ethylene glycol + terephthalic acid', 'Ester', 'Bottles, fabrics'],
            ['Glyptal', 'Ethylene glycol + phthalic acid', 'Ester', 'Paints, lacquers'],
            ['Bakelite', 'Phenol + formaldehyde', 'Methylene', 'Switches, handles'],
            ['Melamine-formaldehyde', 'Melamine + HCHO', 'Methylene', 'Unbreakable crockery'],
            ['Urea-formaldehyde', 'Urea + HCHO', 'Methylene', 'Adhesives, foams'],
          ],
        },
      ],
    },
    {
      id: 'rubber',
      title: {
        english: 'Rubber — Natural & Synthetic',
        hindi: 'रबर — प्राकृतिक और संश्लेषित',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Natural rubber** — *cis*-polyisoprene from latex of *Hevea brasiliensis*. All-*cis* arrangement gives flexible coil; gutta-percha is *all-trans* (rigid).',
        hindi: '**प्राकृतिक रबर** - *सीस*-हेविया ब्रासिलिएन्सिस* के लेटेक्स से पॉलीआइसोप्रीन। ऑल-*सीआईएस* व्यवस्था लचीली कुंडल देती है; गुट्टा-पर्चा *ऑल-ट्रांस* (कठोर) है।',
            },
            {
              english: '**Vulcanisation** (Goodyear, 1839) — heating with **S** at 373-415 K introduces –S–S– cross-links; reduces stickiness, increases tensile strength & elasticity. Hard rubber: ~30 % S; tyre rubber ~5 %.',
        hindi: '**वल्कनीकरण** (गुडइयर, 1839) - 373-415 K पर **S** के साथ गर्म करने से -S-S- क्रॉस-लिंक का परिचय होता है; चिपचिपाहट कम करता है, तन्य शक्ति और लोच बढ़ाता है। कठोर रबर: ~30% एस; टायर रबर ~5%.',
            },
            {
              english: '**Synthetic rubbers** (BUNA series):',
        hindi: '**सिंथेटिक रबर** (बुना श्रृंखला):',
            },
            {
              english: '• BUNA-S = 1,3-butadiene + styrene (SBR) — auto tyres.',
        hindi: '• BUNA-S = 1,3-ब्यूटाडीन + स्टाइरीन (SBR) - ऑटो टायर।',
            },
            {
              english: '• BUNA-N = 1,3-butadiene + acrylonitrile — oil-resistant; used in fuel hoses.',
        hindi: '• BUNA-N = 1,3-ब्यूटाडीन + एक्रिलोनिट्राइल - तेल प्रतिरोधी; ईंधन नली में उपयोग किया जाता है।',
            },
            {
              english: '• Neoprene (polychloroprene from chloroprene) — gaskets, seals; oil-resistant.',
        hindi: '• नियोप्रीन (क्लोरोप्रीन से पॉलीक्लोरोप्रीन) - गैसकेट, सील; आयल प्रतिरोधी।',
            },
          ],
        },
      ],
    },
    {
      id: 'molar-mass-bio',
      title: {
        english: 'Molecular Mass, Tacticity & Biodegradable Polymers',
        hindi: 'आण्विक द्रव्यमान, टैक्टिसिटी और जैव-अपघटनीय बहुलक',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Polymers are **polydisperse**. Two averages:',
        hindi: 'पॉलिमर **पॉलीडिस्पर्स** होते हैं। दो औसत:',
            },
            {
              english: '• **Number-average** $\\overline{M_n} = \\dfrac{\\sum N_i M_i}{\\sum N_i}$.',
        hindi: '• **संख्या-औसत** $\\overline{M_n} = \\dfrac{\\sum N_i M_i}{\\sum N_i}$.',
            },
            {
              english: '• **Weight-average** $\\overline{M_w} = \\dfrac{\\sum N_i M_i^2}{\\sum N_i M_i}$.',
        hindi: '• **वजन-औसत** $\\overline{M_w} = \\dfrac{\\sum N_i M_i^2}{\\sum N_i M_i}$।',
            },
            {
              english: '• **Polydispersity index (PDI)** $= \\overline{M_w}/\\overline{M_n} \\geq 1$. PDI = 1 only if all chains identical.',
        hindi: '• **बहुविभाजन सूचकांक (पीडीआई)** $= \\overline{M_w}/\\overline{M_n} \\geq 1$। पीडीआई = 1 केवल तभी जब सभी शृंखलाएं समान हों।',
            },
            {
              english: 'Tacticity (substituent placement): isotactic (same side), syndiotactic (alternating), atactic (random).',
        hindi: 'रणनीति (स्थानापन्न प्लेसमेंट): आइसोटैक्टिक (एक ही तरफ), सिंडियोटैक्टिक (वैकल्पिक), एटैक्टिक (यादृच्छिक)। **बायोडिग्रेडेबल पॉलिमर**:',
            },
            {
              english: '**Biodegradable polymers**:',
        hindi: '**बायोडिग्रेडेबल पॉलिमर**:',
            },
            {
              english: '• PHBV — poly($\\beta$-hydroxybutyrate-co-$\\beta$-hydroxyvalerate) — controlled drug release.',
        hindi: '• PHBV - पॉली($\\beta$-हाइड्रॉक्सीब्यूटाइरेट-co-$\\beta$-हाइड्रॉक्सीवेलरेट) - नियंत्रित दवा रिलीज।',
            },
            {
              english: '• Nylon-2-Nylon-6 — surgical sutures.',
        hindi: '• नायलॉन-2-नायलॉन-6 — सर्जिकल टांके।',
            },
            {
              english: '• PGA, PLA — sutures, drug carriers.',
        hindi: '• पीजीए, पीएलए - टांके, दवा वाहक।',
            },
          ],
        },
      ],
    },
  ],
  keyFormulas: [
    {
      latex: '\\overline{M_n} = \\dfrac{\\sum N_i M_i}{\\sum N_i}',
      desc: {
        english: 'Number-average mass',
        hindi: 'संख्या-औसत द्रव्यमान',
      },
    },
    {
      latex: '\\overline{M_w} = \\dfrac{\\sum N_i M_i^2}{\\sum N_i M_i}',
      desc: {
        english: 'Weight-average mass',
        hindi: 'भार-औसत द्रव्यमान',
      },
    },
    {
      latex: 'PDI = \\overline{M_w}/\\overline{M_n} \\geq 1',
      desc: {
        english: 'Polydispersity',
        hindi: 'बहुविक्षेपण',
      },
    },
    {
      latex: 'TiCl_4 + Al(C_2H_5)_3',
      desc: {
        english: 'Ziegler-Natta catalyst',
        hindi: 'ज़िग्लर-नट्टा उत्प्रेरक',
      },
    },
    {
      latex: 'n\\,CH_2=CCl-CH=CH_2 \\to (-CH_2-CCl=CH-CH_2-)_n',
      desc: {
        english: 'Neoprene',
        hindi: 'नियोप्रीन',
      },
    },
    {
      latex: '(-NH(CH_2)_6NHCO(CH_2)_4CO-)_n',
      desc: {
        english: 'Nylon-6,6 unit',
        hindi: 'नायलॉन-6,6 इकाई',
      },
    },
    {
      latex: '\\text{Vulcanisation: cross-links via } -S-S-',
      desc: {
        english: 'Improves rubber',
        hindi: 'रबर में सुधार करता है',
      },
    },
  ],
  pyqs: [
    {
      year: 2024,
      exam: 'JEE Main',
      tag: 'Monomer',
      problem: {
        english: 'Monomer of Teflon:',
        hindi: 'टेफ्लॉन का मोनोमर:',
      },
      answer: {
        english: 'Tetrafluoroethene',
        hindi: 'टेट्राफ्लुओरोएथीन',
      },
      solution: {
        english: '$F_2C{=}CF_2$.',
        hindi: '$F_2C{=}CF_2$।',
      },
    },
    {
      year: 2023,
      exam: 'NEET',
      tag: 'Type',
      problem: {
        english: 'Bakelite is:',
        hindi: 'बैकेलाइट है:',
      },
      answer: {
        english: 'Thermosetting condensation polymer',
        hindi: 'थर्मोसेटिंग संघनन बहुलक',
      },
      solution: {
        english: 'Phenol + HCHO with cross-linking.',
        hindi: 'फिनोल + HCHO क्रॉस-लिंकिंग के साथ।',
      },
    },
    {
      year: 2022,
      exam: 'JEE Main',
      tag: 'Rubber',
      problem: {
        english: 'Vulcanisation of rubber involves:',
        hindi: 'रबर के वल्कनीकरण में शामिल है:',
      },
      answer: {
        english: 'Cross-linking by sulphur',
        hindi: 'सल्फर द्वारा क्रॉस-लिंकिंग',
      },
      solution: {
        english: 'Heating natural rubber with S.',
        hindi: 'प्राकृतिक रबर को एस के साथ गर्म करना।',
      },
    },
    {
      year: 2021,
      exam: 'NEET',
      tag: 'Biodegradable',
      problem: {
        english: 'Biodegradable polymer used in surgical sutures:',
        hindi: 'सर्जिकल टांके में उपयोग किया जाने वाला बायोडिग्रेडेबल पॉलिमर:',
      },
      answer: {
        english: 'Nylon-2-Nylon-6 (also PGA)',
        hindi: 'नायलॉन-2-नायलॉन-6 (पीजीए भी)',
      },
      solution: {
        english: 'Hydrolysable amide linkages.',
        hindi: 'लिंकेज के बीच हाइड्रोलाइज़ेबल।',
      },
    },
    {
      year: 2020,
      exam: 'JEE Main',
      tag: 'Catalyst',
      problem: {
        english: 'Ziegler-Natta catalyst:',
        hindi: 'ज़िग्लर-नट्टा उत्प्रेरक:',
      },
      answer: {
        english: '$TiCl_4 + Al(C_2H_5)_3$',
        hindi: '$TiCl_4 + Al(C_2H_5)_3$',
      },
      solution: {
        english: 'Stereoregular HDPE.',
        hindi: 'स्टीरियोरेगुलर एचडीपीई.',
      },
    },
  ],
  next: {
    slug: 'chemistry-everyday-life',
    title: 'Chemistry in Everyday Life',
  },
};

export default chapter;
